export const IDENTIFIERS = ['passwordReset', 'receipt', 'roomPartnerChosen'];
